
import { __ } from '@wordpress/i18n';
import { useLocation, useNavigate } from 'react-router-dom';
import snackbar from 'snackbar';
import { useEffect, useState } from 'react';
import System from '../content/system';
import Demo from '../content/demo';
import { applyFilters } from '@wordpress/hooks';
import Elements from '../content/elements';
import ThemeBuilder from '../content/theme-builder';
import UpgradePopup, { UpgradeProDashboard } from '../content/banner-pro';

const Content = () => {

    const { root, homeSlug, plugins } = window['JkitDashboardOption'];
    const [snackbarString, setSnackbar] = useState(false);

    const [snackbarVisible, setSnackbarVisible] = useState(false);
    const query = new URLSearchParams(useLocation().search);
    const { pathname, search } = useLocation();
    const page = query.get('page');
    const path = query.get('path');
    const subPath = query.get('subpath');
    const param = `?page=${page}&path=demos`;
    const [showBanner, setShowBanner] = useState(false)


    useEffect(() => {
        if (snackbarString && !snackbarVisible) {
            setSnackbarVisible(true);
            snackbar.view = document.querySelector('#wpbody').appendChild(document.createElement('div'));
            snackbar.view.classList.add('snackbar');
            snackbar.duration = 5000;
            snackbar.gap = 250;
            snackbar.show(snackbarString);
            setTimeout(() => {
                setSnackbar(false);
            }, 200);
            setTimeout(() => {
                setSnackbarVisible(false);
            }, 5200);
        }
    }, [snackbarString, snackbarVisible]);

    const navigate = useNavigate();

    const goToLicensePage = () => {
        navigate({
            pathname: pathname,
            search: '?page=jkit&path=license'
        });
    };


    let routePage = '';

    const props = {
        setSnackbar,
        setShowBanner,
        goToLicensePage
    };

    if (root === page) {
        switch (path) {
            case 'demos':
                routePage = <Demo {...props} />;
                break;
            case 'elements':
                routePage = <Elements {...props} />;
                break;
            case 'system-status':
                routePage = <System {...props} />;
                break;
            case 'theme-builder':
                routePage = <ThemeBuilder {...props} />;
                break;
            case null:
                routePage = <Dashboard {...props} />;
                break;
            default:
                '';
                break;
        }
    }

    const paths = {
        path,
        subPath
    };

    routePage = applyFilters(
        'jkit.dashboard.route.content',
        routePage,
        paths,
        props
    );

    return <div className={`f-content ${path ? `f-content__${path}` : 'f-content__dashboard'}`}>
        {routePage}
        {showBanner && <UpgradePopup closeState={setShowBanner} goToLicensePage={goToLicensePage} />}
    </div>;
};



const Dashboard = (props) => {
    const {
        imgDir,
        homeUrl,
        themeVersion,
        ratingUrl,
        upgradeURL,
        forumUrl,
        documentationUrl
    } = window['JkitDashboardOption'];

    const [email, setEmail] = useState('');
    const [extraClass, setExtraClass] = useState('');
    const { setSnackbar } = props;

    const subscribe = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailPattern.test(email)) {
            setExtraClass('loading');
            subscribeNews({
                email,
                site: homeUrl,
            })
                .then((result) => {
                    if (result.message) {
                        setSnackbar(result.message);
                    }
                    setExtraClass('');
                })
                .catch(() => {
                    setSnackbar('Email invalid');
                    setExtraClass('');
                });
        } else {
            setSnackbar('Email invalid');
        }
    };

    return <div className="profecient-dashboard-wrapper">
        <div className="profecient-dashboard-left">
            <div className="profecient-dashboard-wellcome profecient-card">
                <div className="profecient-dashboard-wellcome-content">
                    <div className="description">
                        <h2 className="title">{__('Welcome to Jeg Kit Ecosystem', 'jeg-elementor-kit')}</h2>
                        <span>{__('Congratulations! Jeg Kit has been activated and is ready to be used. Start creating an awesome website with Jeg Kit.', 'jeg-elementor-kit')}</span>
                    </div>
                    <div className="version">
                        <span>
                            {__('Version ', 'jeg-elementor-kit')}
                            {themeVersion ? themeVersion : __('-', 'jeg-elementor-kit')}
                        </span>
                    </div>
                </div>
            </div>
            <div className="profecient-dashboard-thanks profecient-card">
                <div className="profecient-dashboard-thanks-content">
                    <img src={`${imgDir}/admin/dashboard-hero.jpg`}></img>
                    <div className="description">
                        <h2 className="title">{__('Thank you for choosing Jeg Kit', 'jeg-elementor-kit')}</h2>
                        <span>{__('Thank you for bringing happiness to us, We really appreciate you for using Jeg Kit.', 'jeg-elementor-kit')}</span>
                        <span>{__('Take advantage and get familiar with the features Jeg Kit offers and create a stunning site with ease. To get started, be sure to check out the ', 'jeg-elementor-kit')}
                            <a href={documentationUrl} target="_blank" rel="noreferrer">{__('Documentation', 'jeg-elementor-kit')}</a>
                            .</span>
                    </div>
                </div>
            </div>
            <div className="profecient-dashboard-submenu">
                <div className="profecient-dashboard-menu-item profecient-card">
                    <div className="profecient-dashboard-menu-icon">
                        <img src={`${imgDir}/admin/documentation.png`}></img>
                    </div>
                    <div className="profecient-dashboard-menu-content">
                        <div className="description">
                            <h2 className="title">{__('Documentation', 'jeg-elementor-kit')}</h2>
                            <span>{__('Browse our collection of quick guides and tutorials to get the most out of Jeg Kit.', 'jeg-elementor-kit')}</span>
                            <a href={documentationUrl} target="_blank" rel="noreferrer">
                                <span>{__('View Docs', 'jeg-elementor-kit')}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="profecient-dashboard-menu-item profecient-card">
                    <div className="profecient-dashboard-menu-icon">
                        <img src={`${imgDir}/admin/any-question.png`}></img>
                    </div>
                    <div className="profecient-dashboard-menu-content">
                        <div className="description">
                            <h2 className="title">{__('Any Questions?', 'jeg-elementor-kit')}</h2>
                            <span>{__('Our dedicated support team is ready to assist you with any questions or your problems.', 'jeg-elementor-kit')}</span>
                            <a href={forumUrl} target="_blank" rel="noreferrer">
                                <span>{__('Ask For Support', 'jeg-elementor-kit')}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="profecient-dashboard-menu-item profecient-card">
                    <div className="profecient-dashboard-menu-icon">
                        <img src={`${imgDir}/admin/rate-plugin.png`}></img>
                    </div>
                    <div className="profecient-dashboard-menu-content">
                        <div className="description">
                            <h2 className="title">{__('Love the Plugin?', 'jeg-elementor-kit')}</h2>
                            <span>{__('Your review helps us grow and allows others to discover a tool they can trust.', 'jeg-elementor-kit')}</span>
                            <a href={ratingUrl} target="_blank" rel="noreferrer">
                                <span>{__('Rate Us', 'jeg-elementor-kit')}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="profecient-dashboard-right">
            <div className="profecient-dashboard-rating profecient-card">
                {applyFilters('jkit.dashboard.banner', <UpgradeProDashboard goToLicensePage={props.goToLicensePage} withArrow={false} />)}
            </div>
            <div className="profecient-dashboard-subscribe profecient-card">
                <div className="profecient-dashboard-subscribe-wrapper">
                    <div className="description">
                        <h2 className="title">{__('Join to Our Newsletter', 'jeg-elementor-kit')}</h2>
                        <span>{__('Subscribe to get all our news and be the first to get new updates.', 'jeg-elementor-kit')}</span>
                    </div>
                    <div className="profecient-dashboard-form">
                        <input className="profecient-dashboard-email" type="text" placeholder={__('Your Email', 'jeg-elementor-kit')} value={email} onChange={(e) => { setEmail(e.target.value); }} />
                        <a onClick={() => { subscribe(); }} className={extraClass} style={{ width: '100%' }}>
                            {extraClass ? <div className="loading">
                                <Loader size={20} />
                            </div> : <span>{__('Subscribe', 'jeg-elementor-kit')}</span>}
                        </a>
                        <span>{__('✌️ We Promise not spam.', 'jeg-elementor-kit')}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>;
};

export default Content;
